<template>
  <b-modal id="product_map_modal" class="modal" hide-footer>
    <div class="modal-container">
      <div v-if="hasProducts" class="content-grid">
        <product-card
          v-for="(product, i) in products"
          :product="product"
          :key="i"
          @card-clicked="visitProductPage"
          class="product-card"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import ProductCard from "../molecules/product-card";
export default {
  name: "product-map-modal",
  components: { ProductCard },
  props: {
    products: {
      type: Array,
      required: true
    }
  },
  methods: {
    visitProductPage(product) {
      this.$router.push({
        name: "ProductPage",
        params: {
          name: product.name,
          id: product._id,
          sex: this.$route.params.sex
        }
      });
    }
  },
  computed: {
    hasProducts() {
      return this.products && this.products.length > 0;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.modal-container {
  height: 100%;
  width: 100%;
}

.content-grid {
  display: grid;
  grid-gap: 1rem;
  justify-items: center;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  @media (min-width: 1000px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
  @media (min-width: 1327px) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
  @media (min-width: 1500px) {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
  @media (min-width: 1700px) {
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  }
}

.product-card {
  width: 200px;
  height: 350px;
  @media (min-width: 1000px) {
    width: 200px;
    height: 500px;
  }
  @media (min-width: 1327px) {
    width: 250px;
    height: 550px;
  }
  @media (min-width: 1500px) {
    width: 300px;
    height: 600px;
  }
  @media (min-width: 1700px) {
    width: 350px;
    height: 650px;
  }
}
</style>

<style lang="scss">
.modal-dialog {
  width: auto;
  min-height: 90vh;
  margin: 50px;
  max-width: unset;
}
.modal-content {
  height: 100%;
}
.modal-header {
  border: none;
}
</style>
